module.exports = __webpack_public_path__ + "static/img/game-rating-administration-committee.c610fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/game-rating-administration-committee.jpg
// module id = hjlc
// module chunks = 0